import React, { createContext, useContext } from "react";

export enum BlockEnv {
  AGENT = "AGENT",
  EVAL = "EVAL",
  SMART_TABLE = "SMART_TABLE",
}

export const isEvalLikeEnv = (env?: BlockEnv): boolean =>
  env === BlockEnv.EVAL || env === BlockEnv.SMART_TABLE;

interface EnvContextValue {
  env?: BlockEnv;
}

const EnvContext = createContext<EnvContextValue>({ env: undefined });

export interface EnvProviderProps {
  children: React.ReactNode;
  env?: BlockEnv;
}

export const EnvProvider: React.FC<EnvProviderProps> = ({ children, env }) => {
  const value: EnvContextValue = {
    env,
  };

  return <EnvContext.Provider value={value}>{children}</EnvContext.Provider>;
};

export const useEnv = (): EnvContextValue => {
  const context = useContext(EnvContext);

  if (context === null) {
    throw new Error(
      "useEnv must be used within an EnvProvider. " +
        "Make sure to wrap your component with EnvProvider.",
    );
  }

  return context;
};

export const useBlockEnv = (): BlockEnv | undefined => {
  const { env } = useEnv();
  return env;
};
